import badgeDark from '../../../assets/playstore-badge.png';
import badgeLight from '../../../assets/playstore-badge-light.png';

interface PlayStoreBadgeProps {
  href?: string;
  onClick?: () => void;
  className?: string;
  variant?: 'dark' | 'light';
}

export function PlayStoreBadge({ href, onClick, className = '', variant = 'dark' }: PlayStoreBadgeProps) {
  const src = variant === 'light' ? badgeLight : badgeDark;

  const image = (
    <img
      src={src}
      alt="Get it on Google Play"
      className={`${className || 'h-14'} w-auto object-contain`}
      loading="eager"
      decoding="async"
      draggable={false}
    />
  );

  if (!href) {
    return <span className="inline-flex items-center opacity-90">{image}</span>;
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      className="inline-flex items-center hover:opacity-90 transition-opacity duration-200"
      aria-label="Get it on Google Play"
    >
      {image}
    </a>
  );
}

export default PlayStoreBadge;
